import React, { useEffect, useState } from "react";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getTotalAgreementsList,
  getAgreementsCsvDownload,
  getTotalAgreementsListType,
} from "../../utilities/apis/agreements";
import AgreementGraph from "./AgreementGraph";
import HamburgerMenuAgreements from "../HamburgerMenuAgreements";
import AgreementGraph1 from "./AgreementGraph1";
import AgreementAnalytics1 from "../../components/AgreementAnalytics/AgreementAnalytics1";

const statusOptions = [
  {
    label: "Pending with Company",
    value: "Pending with Company",
  },
  {
    label: "TP",
    value: "TP",
  },
];

const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const AgreementsAllStatus = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [configs, setConfigs] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });
  const [filters, setFilter] = useState({
    typeOfAgreement: null,
    mapBusinessunit: null,
  });

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        // sync creation of filter object
        const filtersForData = Object.fromEntries(
          Object.entries(filters).filter(([key, value]) => value !== null),
        );
        const response = await apiWrapWithErrorWithData(
          getTotalAgreementsList({ filterOptions: filtersForData, year: year }),
        );
        const response2 = await apiWrapWithErrorWithData(
          getTotalAgreementsListType({ filterOptions: filtersForData, year }),
        );

        // if (response.success && response2.success) {
        //   // create a small summary to avoid freezing the UI
        // const dataToSet = {
        //   success: !!response.success,
        //   agreementByMonth:
        //     response.agreementByMonth && response.agreementByMonth,
        //   agreementByYear:
        //     response.agreementByYear && response.agreementByYear,
        // agreementsLocationWise:
        //   response.agreementsLocationWise &&
        //   response.agreementsLocationWise,
        // agreementTypeWise:
        //   response2.agreementTypeWise && response2.agreementTypeWise,

        // };
        //
        //   setConfigs({
        //     loading: loadingStates.NO_ACTIVE_REQUEST,
        //     data: dataToSet,
        //   });
        //   if (cancelled) return;
        // }
        if (response.success && response2.success) {
          const normalizedAgreementByMonth = (
            response.agreementByMonth2 || []
          ).map((item) => ({
            month: item.month,
            _avg: {
              noOfCompletionDays: item._avg_noOfCompletionDays,
            },
            _count: {
              id: item._count_id,
            },
          }));

          const normalizedAgreementByYear = (
            response.agreementByYear2 || []
          ).map((item) => ({
            // year: item.contract_year,
            year: Number(String(item.contract_year).slice(-2)), // convert 2026 → 26
            _avg: {
              noOfCompletionDays: item.avg_noOfCompletionDays,
            },
            _count: {
              id: item.count_id,
            },
          }));

          const dataToSet = {
            success: !!response.success,
            agreementByMonth: normalizedAgreementByMonth,
            agreementByYear: normalizedAgreementByYear,
            agreementsLocationWise:
              response.agreementsLocationWise &&
              response.agreementsLocationWise,
            agreementTypeWise:
              response2.agreementTypeWise && response2.agreementTypeWise,
          };

          setConfigs({
            loading: loadingStates.NO_ACTIVE_REQUEST,
            data: dataToSet,
          });

          if (cancelled) return;
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    const wrappedFetch = async () => {
      try {
        await fetchData();
      } catch (e) {
        /* handled inside fetchData */
      }
    };
    wrappedFetch();
    return () => {
      cancelled = true;
    };
  }, [filters, year]);

  return (
    <>
      <div
        className="flex"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "600",
            letterSpacing: "1px",
            fontFamily: "lexend",
            whiteSpace: "nowrap",
            paddingBottom: "13px",

            position: "relative",
            color: "black",
            // margin: "0 auto"
          }}
        >
          total agreements
        </h1>

        <HamburgerMenuAgreements />
      </div>
      <div className="flex flex-row flex-wrap w-full">
        <AgreementAnalytics1
          filter={filters}
          setFilter={setFilter}
          configs={configs}
        />
      </div>
      <div className="grid grid-cols-2 gap-4 mt-4">
        <AgreementGraph setYear={setYear} year={year} configs={configs} />
        <AgreementGraph1 configs={configs} />
      </div>
    </>
  );
};

export default AgreementsAllStatus;
